import { BlipApi } from './BlipApi';

const COPILOT_POSTMASTER = 'postmaster@copilot.msging.net';

export const enableCopilot = async (ownerIdentity) => {
  try {
    const response = await BlipApi.sendCommand({
      to: COPILOT_POSTMASTER,
      method: 'set',
      uri: `lime://${ownerIdentity}/copilot/enable`,
      type: 'application/json',
      resource: {},
    });
    return response;
  } catch (e) {
    console.error(e);
    return;
  }
};

export const disableCopilot = async (ownerIdentity) => {
  try {
    const { response } = await BlipApi.sendCommand({
      to: COPILOT_POSTMASTER,
      method: 'set',
      uri: `lime://${ownerIdentity}/copilot/disable`,
      type: 'application/json',
      resource: {},
    });
    return response;
  } catch (e) {
    console.error(e);
    return;
  }
};

export const CopilotApi = {
  enableCopilot,
  disableCopilot,
};
